<template>
  <v-container>
    <v-overlay :absolute="absolute" :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Configuracion de grupos de trabajo</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="mt-4">
          <v-card-text>
            <v-form>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="clientsWorkgroups.clientId"
                    :items="clientsNames"
                    solo
                    filled
                    :append-icon="'mdi-account-group'"
                    :no-data-text="'No se encontraron clientes'"
                    label="Seleccione a un Cliente"
                    placeholder="Seleccione a un Cliente"
                    @change="getClientWorkgroup"
                    class="mb-5 rounded-lg"
                  ></v-autocomplete>
                  <v-select
                    v-model="day"
                    label="Seleccione un Día de la semana"
                    :items="daysOfTheWeek"
                    item-value="value"
                    item-text="label"
                    solo
                    :disabled="clientsWorkgroups.clientId ? false : true"
                    @change="getClientWorkgroup"
                    class="rounded-lg"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-row v-for="schedule in schedules" :key="schedule.id">
                    <v-col class="d-flex" cols="12">
                      <v-select
                        :items="workgroupsNames"
                        :label="schedule.name"
                        v-model="scheduleValue[schedule.id]"
                        solo
                        v-if="
                          clientsWorkgroups.clientId && !loading ? true : false
                        "
                        class="rounded-lg"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    elevation="2"
                    class="text-center float-right btn-row"
                    @click="saveClientWorkgroup"
                    block
                    color="secondary"
                    dark
                    >Guardar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
export default {
  data() {
    return {
      loading: false,
      overlay: true,
      absolute: true,
      daysOfTheWeek: [
        { value: "monday", label: "Lunes" },
        { value: "tuesday", label: "Martes" },
        { value: "wednesday", label: "Miércoles" },
        { value: "thursday", label: "Jueves" },
        { value: "friday", label: "Viernes" },
        { value: "saturday", label: "Sábado" },
        { value: "sunday", label: "Domingo" }
      ],
      clients: [],
      clientsNames: [],
      alertSnackbar: false,
      snackbarText: "",
      schedules: [],
      day: "lunes",
      workgroups: [],
      workgroupsNames: [],
      scheduleValue: [],
      setSchedule: [],
      clientsWorkgroups: {
        schedules: []
      }
    };
  },
  mounted() {
    this.workgroupsNames.push({
      text: "No seleccionado",
      value: null
    });
    this.getSchedules();
    this.getClients();
    this.getGroups();
  },
  computed: {},
  methods: {
    getSchedules() {
      this.overlay = true;
      let url = Config.url + "/db/schedules";
      this.axios
        .get(url)
        .then(res => {
          this.schedules = res.data.schedules;
          this.schedules.forEach(item => {
            this.scheduleValue[item.id] = null;
          });
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de horarios";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getClients() {
      this.overlay = true;
      let url = Config.url + "/db/clients";
      this.axios
        .get(url)
        .then(res => {
          this.clients = res.data.clients;
          this.clients.forEach(item => {
            this.clientsNames.push({ text: item.name, value: item.id });
          });
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de Clientes";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getGroups() {
      this.overlay = true;
      let url = Config.url + "/db/workgroups";
      this.axios
        .get(url)
        .then(res => {
          this.groups = res.data.workgroups;
          this.groups.forEach(item => {
            this.workgroupsNames.push({
              text: item.name,
              value: item.id
            });
          });
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de Grupos";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getClientWorkgroup() {
      this.overlay = true;
      this.loading = true;
      let url =
        Config.url + "/db/client/workgroup/" + this.clientsWorkgroups.clientId;
      this.axios
        .get(url)
        .then(res => {
          this.scheduleValue = [];
          if (res.status == 200) {
            res.data.schedules.forEach(element => {
              if (element.day == this.day) {
                this.scheduleValue[element.scheduleId] = parseInt(
                  element.workgroupId
                );
              }
            });
          }
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    checkSchedules() {
      let count = 0;
      if (this.scheduleValue.length > 0) {
        this.scheduleValue.forEach(item => {
          if (!item) {
            count++;
          }
        });
        if (count > 0) return false;
        return true;
      } else {
        return false;
      }
    },
    saveClientWorkgroup() {
      if (this.checkSchedules()) {
        this.setSchedule = [];
        this.scheduleValue.map((item, index) => {
          this.setSchedule.push({
            workgroupId: item,
            scheduleId: index
          });
        });
        this.clientsWorkgroups.schedules = this.setSchedule;
        this.clientsWorkgroups.day = this.day;
        console.log(this.clientsWorkgroups);
        let url = Config.url + "/db/client/workgroup";
        this.overlay = true;
        this.loading = true;
        this.axios
          .post(url, this.clientsWorkgroups)
          .then(res => {
            if (res.status == 201) {
              this.snackbarText =
                "Los horarios y grupos han sido asignados exitosamente";
              this.alertSnackbar = true;
            }
          })
          .catch(err => {
            console.log(err);
            this.snackbarText =
              "Error en servidor, falló al guardar los horarios y grupos correspondientes";
            this.alertSnackbar = true;
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      } else {
        this.snackbarText = "Por favor complete todos los horarios";
        this.alertSnackbar = true;
      }
    }
  }
};
</script>

<style></style>
